import React from "react";

import { Typography } from "@mui/material";

import ProfilIcon from "../../../../Assets/svg/menu/features/ProfilIconHeader";
import CustomHeader from "../CustomHeader/CustomHeader";

const HeaderRupture: React.FC = () => (
  <CustomHeader
    childLeft={
      <div
        style={{
          alignItems: "flex-start",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          style={{ fontSize: 24, fontWeight: "bold", color: "#ffffff" }}
        >
          Info Ruptures
        </Typography>
      </div>
    }
    icon={
      <ProfilIcon
        viewBox="100 20 90 100"
        fill="#ffffff50"
        opacity={0.5}
        style={{
          height: "138px",
          width: "425px",
        }}
      />
    }
  />
);

export default HeaderRupture;
